import { X } from "lucide-react";

/**
 * NestedModal — a second-layer modal that sits above the vehicle-form
 * modal. Higher z-index so it wins over the parent overlay; clicking
 * the scrim only closes the nested layer.
 */
export function NestedModal({ title, children, onClose, testId, wide = false }) {
  const widthClass = wide ? "max-w-5xl" : "max-w-4xl";
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4"
      onClick={onClose}
      data-testid={testId}
    >
      <div
        className={`bg-white dark:bg-[#1F2937] text-[#0A0A0A] dark:text-[#F9FAFB] ${widthClass} w-full px-8 py-8 max-h-[85vh] overflow-y-auto rounded border border-black/10 dark:border-white/10`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-display text-2xl">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            data-testid={`${testId}-close`}
            className="text-neutral-400 hover:text-black dark:hover:text-white"
          >
            <X size={20} />
          </button>
        </div>
        {children}
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="bg-black text-white dark:bg-white dark:text-black px-5 py-2 text-sm hover:opacity-90 rounded"
            data-testid={`${testId}-done`}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

/**
 * ModalOpenerCard — clickable summary card that opens a nested modal.
 */
export function ModalOpenerCard({ title, count, countLabel, onOpen, testId, hint }) {
  const label = count === 1 ? countLabel : `${countLabel}s`;
  return (
    <button
      type="button"
      onClick={onOpen}
      data-testid={testId}
      className="text-left border border-black/10 dark:border-white/10 hover:border-black dark:hover:border-white rounded p-4 transition-colors group"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-display text-lg leading-tight">{title}</p>
          {hint && <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">{hint}</p>}
        </div>
        <span
          className={`text-xs px-2 py-1 rounded ${
            count > 0
              ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300"
              : "bg-neutral-100 text-neutral-600 dark:bg-neutral-800 dark:text-neutral-300"
          }`}
        >
          {count} {label}
        </span>
      </div>
      <p className="text-[11px] uppercase tracking-widest text-neutral-500 dark:text-neutral-400 mt-3 group-hover:text-black dark:group-hover:text-white">
        Open editor →
      </p>
    </button>
  );
}
